import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import determinarPaginaAtual from '../../actions/mapa-veiculo/determinarPaginaAtualMapasVeiculos'
import alterarRegistrosPorPagina from '../../actions/mapa-veiculo/alterarRegistrosPorPaginaMapasVeiculos'

export class PaginacaoPedidos extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtual,
    alterarRegistrosPorPagina
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualMapasVeiculos,
    total: state.mapasVeiculos.total,
    registrosPorPagina: state.registrosPorPaginaMapasVeiculos
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoPedidos)
